export default __webpack_public_path__ + "static/media/badge-1.8e7df201.png";